import React from 'react';
import './Legal.css';

function Terms() {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: November 12, 2024</p>
        
        <section>
          <h2>Agreement to Terms</h2>
          <p>
            By accessing and using the ChapterChat mobile application ("Service"), operated by ShareSpace Apps
            ("Company," "we," "our," or "us"), you agree to be bound by these Terms of Service ("Terms").
            If you disagree with any part of these terms, then you may not access the Service.
          </p>
        </section>

        <section>
          <h2>Description of Service</h2>
          <p>
            ChapterChat is a digital bookshelf application that allows users to:
          </p>
          <ul>
            <li>Organize and track their book collections</li>
            <li>Connect with friends and share reading activities</li>
            <li>Join and participate in book clubs</li>
            <li>Discover new books through recommendations</li>
            <li>Track reading progress and statistics</li>
          </ul>
        </section>

        <section>
          <h2>User Accounts</h2>
          <h3>Account Creation</h3>
          <ul>
            <li>You must provide accurate and complete information when creating an account</li>
            <li>You are responsible for maintaining the security of your account</li>
            <li>You must be at least 13 years old to create an account</li>
            <li>One account per person; multiple accounts are not permitted</li>
          </ul>
          
          <h3>Account Responsibilities</h3>
          <ul>
            <li>You are responsible for all activities that occur under your account</li>
            <li>Notify us immediately of any unauthorized use of your account</li>
            <li>Keep your login credentials secure and confidential</li>
          </ul>
        </section>

        <section>
          <h2>User Conduct</h2>
          <h3>Acceptable Use</h3>
          <p>You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:</p>
          <ul>
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe on the rights of others</li>
            <li>Post harmful, offensive, or inappropriate content</li>
            <li>Harass, bully, or intimidate other users</li>
            <li>Share false or misleading information</li>
            <li>Attempt to gain unauthorized access to the Service or other users' accounts</li>
            <li>Use the Service for commercial purposes without permission</li>
          </ul>

          <h3>Content Standards</h3>
          <p>All user-generated content (reviews, comments, posts) must:</p>
          <ul>
            <li>Be respectful and appropriate for all audiences</li>
            <li>Not contain spam, advertising, or promotional material</li>
            <li>Not infringe on copyrights or other intellectual property rights</li>
            <li>Be relevant to books and reading</li>
          </ul>
        </section>

        <section>
          <h2>Content and Intellectual Property</h2>
          <h3>User Content</h3>
          <ul>
            <li>You retain ownership of content you create and post</li>
            <li>You grant us a license to use, display, and distribute your content within the Service</li>
            <li>You are responsible for ensuring you have rights to any content you post</li>
            <li>We may remove content that violates these Terms</li>
          </ul>

          <h3>Service Content</h3>
          <ul>
            <li>The Service and its original content are owned by ShareSpace Apps</li>
            <li>Book information may be sourced from third parties (Google Books, etc.)</li>
            <li>You may not copy, modify, or distribute our proprietary content</li>
          </ul>
        </section>

        <section>
          <h2>Privacy</h2>
          <p>
            Your privacy is important to us. Our collection and use of personal information is governed by our
            <a href="/privacy"> Privacy Policy</a>, which is incorporated into these Terms by reference.
          </p>
        </section>

        <section>
          <h2>Social Features</h2>
          <h3>Friend Connections</h3>
          <ul>
            <li>You can connect with other users as friends</li>
            <li>Friend connections are mutual and require acceptance from both parties</li>
            <li>You can control your privacy settings and visibility to friends</li>
          </ul>

          <h3>Book Clubs</h3>
          <ul>
            <li>You can join or create book clubs to discuss books with other users</li>
            <li>Book club administrators have the right to moderate discussions and remove members</li>
            <li>All book club activities must comply with our community standards</li>
          </ul>
        </section>

        <section>
          <h2>Termination</h2>
          <h3>By You</h3>
          <ul>
            <li>You may delete your account at any time through the app settings</li>
            <li>Deletion is permanent and cannot be undone</li>
          </ul>

          <h3>By Us</h3>
          <ul>
            <li>We may suspend or terminate accounts that violate these Terms</li>
            <li>We may discontinue the Service with reasonable notice</li>
            <li>We reserve the right to refuse service to anyone</li>
          </ul>
        </section>

        <section>
          <h2>Disclaimers</h2>
          <ul>
            <li>The Service is provided "as is" without warranties of any kind</li>
            <li>We do not guarantee the accuracy of book information or user-generated content</li>
            <li>We are not responsible for interactions between users</li>
            <li>We do not endorse user opinions or recommendations</li>
          </ul>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, ShareSpace Apps shall not be liable for any indirect,
            incidental, special, consequential, or punitive damages, or any loss of profits or revenues,
            whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses.
          </p>
        </section>

        <section>
          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of significant
            changes through the app or by email. Continued use of the Service after changes constitutes
            acceptance of the new Terms.
          </p>
        </section>

        <section>
          <h2>Contact Information</h2>
          <p>
            If you have questions about these Terms of Service, please contact us:
          </p>
          <ul>
            <li>Email: <a href="mailto:admin@sharespaceapps.com">admin@sharespaceapps.com</a></li>
            <li>Through the app's support section</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Terms;